export const ApiRoutes = {
  userState: {
    getUserTaskState: (userId: string): string => `facade/v1/portal/users/${encodeURIComponent(userId)}/task-state`,
  },
  responsibilityProfile: {
    getUserResponsibilityProfiles: (userId: string): string =>
      `user-manager/v1/users/${encodeURIComponent(userId)}/responsibility-profiles`,
    activateUserResponsibilityProfile: (userId: string, responsibilityProfileId: string): string =>
      `user-manager/v1/users/${encodeURIComponent(userId)}/responsibility-profiles/${encodeURIComponent(responsibilityProfileId)}/activate`,
  },
};
